<template>
  <div id="app">
    <notifications style="margin-top:5px" group="inter" position="top right">
      <template slot="body" slot-scope="props">
        <div :class="`custom-notification ${props.item.type}`">
          <div class="grid">
            <div class="title">
              <h3>
                {{$t(`general.${props.item.title}`)}}
              </h3>
            </div>
            <div class="texto">
              <p v-html="props.item.text"></p>
            </div>
            <div class="close">
              <v-icon @click="props.close">cancel</v-icon>
            </div>
          </div>
        </div>
      </template>
    </notifications>
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  data: () => ({
    permissions: []
  }),
  computed: {
    userLogged () {
      return this.$store.state.userLogged
    }
  },
  watch: {
    // userLogged () {
    //   if (this.userLogged.roles) {
    //     let permissions = []
    //     this.userLogged.roles[0].permissions.map(item => {
    //       permissions.push(item.name)
    //     })
    //     this.permissions = permissions
    //   }
    // },
    $route () {
      // if (this.permissions.length > 0 && !this.permissions.find(item => item === this.$route.meta.rule)) {
      //   this.$router.push('/')
      // }
      setTimeout(() => {
        this.$notify({
          group: 'inter',
          clean: true
        })
      }, 1600)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
  .vue-dropzone {
    border: none !important;
    margin-top: 10px;
  }
  .v-select--chips .v-select__selections {
    padding-top: 10px !important;
  }
</style>
<style scoped>
.custom-notification {
  padding: 10px;
  margin: 0 5px 5px;
  font-size: 12px;
  color: #ffffff;
  background: #44A4FC;
  border-left: 5px solid #187FE7;
 
}
.custom-notification.warn {
  background: #ffb648;
  border-left-color: #f48a06;
}

.custom-notification.error {
  background: #E54D42;
  border-left-color: #B82E24;
}

.custom-notification.success {
  background: #68CD86;
  border-left-color: #42A85F;
}

.text {
  font-size: 14px;
}

.grid {
  display: grid;
  grid-template-columns: 80% 20%;
  grid-template-areas: "title close"
                       "texto close";
}

.title {
  grid-area: title;
  padding-bottom: 5px;
}

.texto {
  grid-area: texto;
  font-size: 10pt;
}

.close {
  grid-area: close;
  align-self: center;
  justify-self: end;
}
</style>
